import React, { useState, useEffect } from 'react';
import { DollarSign } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const CurrencyUnits = ({ onSubmit, initialData }) => {
  const { t } = useTranslation();
  const [baseCurrency, setBaseCurrency] = useState('');
  const [errors] = useState({});

  const currencies = [
    { code: 'PLN', name: 'Polish Złoty' },
    { code: 'EUR', name: 'Euro' },
    { code: 'USD', name: 'US Dollar' },
    { code: 'GBP', name: 'British Pound' },
    { code: 'CHF', name: 'Swiss Franc' },
    { code: 'SEK', name: 'Swedish Krona' },
    { code: 'NOK', name: 'Norwegian Krone' },
    { code: 'DKK', name: 'Danish Krone' },
    { code: 'CZK', name: 'Czech Koruna' },
    { code: 'HUF', name: 'Hungarian Forint' }
  ];

  // Load data from localStorage
  useEffect(() => {
    const savedData = localStorage.getItem('scopeBoundaries_currencyUnits');
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        if (parsedData.baseCurrency) setBaseCurrency(parsedData.baseCurrency);
      } catch (error) {
        console.error('Error loading currency data:', error);
      }
    }
  }, []);

  // Validation can be handled externally before completion if needed

  // Completion handled by WorkflowTabView

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="mb-6">
        <div className="flex items-center mb-4">
          <DollarSign className="h-6 w-6 text-blue-600 mr-3" />
          <h2 className="text-xl font-semibold text-gray-900">{t('workflow.scopeBoundaries.currencyUnits.title')}</h2>
        </div>
        <p className="text-gray-600">{t('workflow.scopeBoundaries.currencyUnits.description')}</p>
      </div>

      {/* Base Currency */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t('workflow.scopeBoundaries.currencyUnits.form.baseCurrency')}
        </label>
        <select
          value={baseCurrency}
          onChange={(e) => setBaseCurrency(e.target.value)}
          className={`w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 ${
            errors.baseCurrency ? 'border-red-500' : 'border-gray-300'
          }`}
        >
          <option value="">{t('workflow.scopeBoundaries.currencyUnits.form.selectBaseCurrency')}</option>
          {currencies.map(currency => (
            <option key={currency.code} value={currency.code}>
              {currency.name} ({currency.code})
            </option>
          ))}
        </select>
        {errors.baseCurrency && (
          <p className="mt-1 text-sm text-red-600">{errors.baseCurrency}</p>
        )}
      </div>

      {/* Summary */}
      {baseCurrency && (
        <div className="mb-6 p-4 bg-gray-50 rounded-lg">
          <h3 className="text-sm font-medium text-gray-700 mb-2">{t('workflow.scopeBoundaries.currencyUnits.summary.title')}</h3>
          <div className="text-sm text-gray-600">
            <p><strong>{t('workflow.scopeBoundaries.currencyUnits.summary.baseCurrency')}:</strong> {baseCurrency}</p>
            <p><strong>{t('workflow.scopeBoundaries.currencyUnits.summary.purpose')}:</strong> Consistent intensities and safe conversions</p>
          </div>
        </div>
      )}

      {/* No navigation here; handled by WorkflowTabView */}
    </div>
  );
};

export default CurrencyUnits;
